export default "__VITE_ASSET__D$zVOnkR__"